export const CONFIG_ADDRESSES = 'tenant.addresses';
export const CONFIG_LOAN_TYPE = 'inventory-loanTypeName';
export const MODULE_ORDERS = 'ORDERS';
export const MODULE_TENANT = 'TENANT';
